import { SET_FORGOTPASSWORD_DATA, CLEAR_FORGOTPASSWORD_DATA } from './types.js'
import axios from 'axios'
export default {
    updateForgotPasswordData({ commit }, payload) {
        commit(SET_FORGOTPASSWORD_DATA, payload)
    },
    clearForgotPasswordData({ commit }) {
        commit(CLEAR_FORGOTPASSWORD_DATA)
    },
    async requestForgotPassword ({ state }) {
    let data = Object.assign({ ...state })
      return axios.post('/api/auth/forgot-password', data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            return Promise.reject(error)
        })
    }
}